export const pathway = [
    {
        key: '4',
        name: 'How many credits of completed undergraduate courses do you have?',
        options: [
            {
                name: 'I have < 24 credits completed of undergraduate courses',
                value: '1',
            },
            {
                name: 'I have between 24 to 60 credits completed of undergraduate courses',
                value: '2',
            },
        ]
    },
];
